import { FC, useState, useEffect } from "react";
import {
  StyledWrappedTextArea,
  StyledTextarea,
  StyledLabel,
  ErrorMessage
} from "./TextAreaWithValidation.style";

interface ITextareaProps {
  name: string;
  label?: string;
  placeholder?: string;
  value?: string | number;
  error: string | undefined;
  isDisabled?: boolean;
  isRequired?: boolean;
  isShadow?: boolean;
  onBlur?: () => void;
  onChange?: (arg: string) => void;
}

export const TextAreaWithValidation: FC<ITextareaProps> = (props): JSX.Element => {
  const { 
    name = "",
    label = "",
    placeholder = "",
    value = "",
    error = "",
    isDisabled = false,
    isRequired = false,
    isShadow = false,
    onBlur,
    onChange,
  } = props;

  const [isFocus, setIsFocus] = useState(false);
  const [fieldValue, setFieldValue] = useState(value);

  useEffect(() => setFieldValue(value), [value]);

  const handlerBlur = () => {
    setIsFocus(false);
    if (onBlur) onBlur();
  }

  const handleTextareaChange = (
    event: React.FormEvent<HTMLTextAreaElement>
  ): void => {
    const textAreaValue: string = event.currentTarget.value;

    setFieldValue(textAreaValue);
    if (onChange) {
      onChange(textAreaValue);
    }
  };

  return (
    <StyledWrappedTextArea>
      <StyledLabel isRequired={isRequired}>{ label }</StyledLabel>
      <StyledTextarea 
        name={name}
        isError={!!error}
        value={fieldValue}
        isShadow={isShadow}
        placeholder={placeholder}
        onChange={(event) => handleTextareaChange(event)}
        onBlur={handlerBlur}
        onFocus={() => setIsFocus(!isFocus)}
        disabled={isDisabled} 
      />
      { error && <ErrorMessage>{ error }</ErrorMessage> }
    </StyledWrappedTextArea>
  );
};